import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createBlock as _createBlock, vModelText as _vModelText, withDirectives as _withDirectives } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = { class: "uk-table uk-table-small uk-margin-top uk-text-left uk-table-striped" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 0 }
const _hoisted_5 = ["onClick"]
const _hoisted_6 = { key: 1 }
const _hoisted_7 = {
  key: 1,
  class: "uk-container"
}
const _hoisted_8 = { class: "uk-table uk-table-small uk-margin-remove" }
const _hoisted_9 = { class: "uk-padding-remove" }
const _hoisted_10 = { class: "uk-padding-remove" }
const _hoisted_11 = ["onUpdate:modelValue"]
const _hoisted_12 = { class: "uk-flex uk-flex-right" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_TripTypeField = _resolveComponent("TripTypeField")!
  const _component_Button = _resolveComponent("Button")!

  return (_openBlock(), _createElementBlock("div", null, [
    _cache[12] || (_cache[12] = _createElementVNode("h1", null, "Payable", -1)),
    (_ctx.trips)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("table", _hoisted_2, [
            _createElementVNode("thead", null, [
              _cache[0] || (_cache[0] = _createElementVNode("th", null, "Order #/Container", -1)),
              _cache[1] || (_cache[1] = _createElementVNode("th", null, "Trip Type", -1)),
              _cache[2] || (_cache[2] = _createElementVNode("th", null, "Driver Name", -1)),
              _cache[3] || (_cache[3] = _createElementVNode("th", null, "Origin", -1)),
              _cache[4] || (_cache[4] = _createElementVNode("th", null, "Destination", -1)),
              _cache[5] || (_cache[5] = _createElementVNode("th", null, "Trip Start/End", -1)),
              _cache[6] || (_cache[6] = _createElementVNode("th", null, "Total Payable", -1)),
              (this.selectedTrip)
                ? (_openBlock(), _createElementBlock("th", _hoisted_3))
                : _createCommentVNode("", true)
            ]),
            (!this.selectedTrip)
              ? (_openBlock(), _createElementBlock("tbody", _hoisted_4, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.trips, (trip) => {
                    return (_openBlock(), _createElementBlock("tr", {
                      key: trip.id,
                      onClick: ($event: any) => (_ctx.selectTrip(trip))
                    }, [
                      _createElementVNode("td", null, _toDisplayString(_ctx.container.containerId), 1),
                      _createElementVNode("td", null, [
                        _createVNode(_component_TripTypeField, {
                          showname: false,
                          trip: trip,
                          isEditing: false,
                          darkGreen: trip.status == 'Complete',
                          gray: 
                  trip.status != 'Complete' && trip.status != 'In Progress'
                ,
                          green: trip.status == 'In Progress'
                        }, null, 8, ["trip", "darkGreen", "gray", "green"])
                      ]),
                      _createElementVNode("td", null, _toDisplayString(trip.driver ? trip.driver.fullName : ''), 1),
                      _createElementVNode("td", null, _toDisplayString(trip.origin.name), 1),
                      _createElementVNode("td", null, _toDisplayString(trip.destination.name), 1),
                      _createElementVNode("td", null, _toDisplayString(trip.scheduledDate ? _ctx.formatDate(trip.scheduledDate) : '--'), 1),
                      _createElementVNode("td", null, _toDisplayString(trip.totalPayable), 1),
                      _createElementVNode("td", null, [
                        (trip.driver)
                          ? (_openBlock(), _createBlock(_component_Button, { key: 0 }, {
                              default: _withCtx(() => [...(_cache[7] || (_cache[7] = [
                                _createTextVNode("Add Charges", -1)
                              ]))]),
                              _: 1
                            }))
                          : (_openBlock(), _createBlock(_component_Button, {
                              key: 1,
                              disabled: "",
                              "uk-tooltip": "Please add Driver before adding charges to trip"
                            }, {
                              default: _withCtx(() => [...(_cache[8] || (_cache[8] = [
                                _createTextVNode("Add Charges", -1)
                              ]))]),
                              _: 1
                            }))
                      ])
                    ], 8, _hoisted_5))
                  }), 128))
                ]))
              : (_openBlock(), _createElementBlock("tbody", _hoisted_6, [
                  _createElementVNode("tr", null, [
                    _createElementVNode("td", null, _toDisplayString(_ctx.container.containerId), 1),
                    _createElementVNode("td", null, [
                      _createVNode(_component_TripTypeField, {
                        showname: false,
                        trip: _ctx.selectedTrip,
                        isEditing: false,
                        darkGreen: _ctx.selectedTrip.status == 'Complete',
                        gray: 
                  _ctx.selectedTrip.status != 'Complete' &&
                  _ctx.selectedTrip.status != 'In Progress'
                ,
                        green: _ctx.selectedTrip.status == 'In Progress'
                      }, null, 8, ["trip", "darkGreen", "gray", "green"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(_ctx.selectedTrip.driver ? _ctx.selectedTrip.driver.name : ''), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.selectedTrip.origin.name), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.selectedTrip.destination.name), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.selectedTrip.scheduledDate
                  ? _ctx.formatDate(_ctx.selectedTrip.scheduledDate)
                  : '--'), 1),
                    _createElementVNode("td", null, _toDisplayString(_ctx.selectedTrip.totalPayable), 1)
                  ])
                ]))
          ])
        ]))
      : _createCommentVNode("", true),
    (this.selectedTrip)
      ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
          _createElementVNode("table", _hoisted_8, [
            _createElementVNode("tbody", null, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tripCharges, (charge, chargeIdx) => {
                return (_openBlock(), _createElementBlock("tr", { key: chargeIdx }, [
                  _createElementVNode("td", _hoisted_9, _toDisplayString(charge.name), 1),
                  _createElementVNode("td", _hoisted_10, [
                    _cache[9] || (_cache[9] = _createTextVNode(" $", -1)),
                    _withDirectives(_createElementVNode("input", {
                      type: "text",
                      class: "uk-input uk-width-small uk-form-small",
                      "onUpdate:modelValue": ($event: any) => ((charge.amount) = $event)
                    }, null, 8, _hoisted_11), [
                      [_vModelText, charge.amount]
                    ])
                  ])
                ]))
              }), 128))
            ])
          ]),
          _createElementVNode("div", _hoisted_12, [
            _createVNode(_component_Button, {
              onClick: _ctx.updateDriverCharges,
              class: "uk-flex"
            }, {
              default: _withCtx(() => [...(_cache[10] || (_cache[10] = [
                _createTextVNode(" Update Charges", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"]),
            _createVNode(_component_Button, {
              onClick: _ctx.cancelSelectedTrip,
              isGray: true,
              class: "uk-flex"
            }, {
              default: _withCtx(() => [...(_cache[11] || (_cache[11] = [
                _createTextVNode(" Back to all trips", -1)
              ]))]),
              _: 1
            }, 8, ["onClick"])
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}